var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 12.1687L13.0346 18.0341L11.5025 16.5021L14.7525 13.2521L5.45125 13.2521L5.45125 11.0854L14.7525 11.0854L11.5025 7.83541L13.0346 6.30334L18.9 12.1687Z",
    fill: "#FF3900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9513 0.252075C18.5326 0.252075 23.8679 5.58735 23.8679 12.1687C23.8679 18.7501 18.5326 24.0854 11.9513 24.0854C5.36986 24.0854 0.0345851 18.7501 0.0345854 12.1687C0.0345857 5.58735 5.36986 0.252074 11.9513 0.252075ZM21.7013 12.1687C21.7013 6.78397 17.336 2.41874 11.9513 2.41874C6.56648 2.41874 2.20125 6.78396 2.20125 12.1687C2.20125 17.5535 6.56648 21.9187 11.9513 21.9187C17.336 21.9187 21.7013 17.5535 21.7013 12.1687Z",
    fill: "#FF3900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bce9435fcf592f574b36b9a46125ed67.svg";
export { ForwardRef as ReactComponent };